import React from "react";
import { useNavigate } from "react-router-dom";
import PlaceholderImg from "../assets/images/new_ui/placeholder.jpg";
import RawFoodPlaceholder from "../assets/images/new_ui/raw-food-placeholder.jpg";
import NumberFormat from "react-number-format";

const BusinessCard = ({ item, type, isOpen = true }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (type === "restaurant") {
      navigate(`/restaurant/${item.businessId}`);
    } else if (type === "store") {
      navigate(`/store/${item.businessId}`);
    } else if (type === "raw_food") {
      navigate(`/raw_food`);
    }
  };

  const renderStars = (rating) => {
    return Array(5)
      .fill(0)
      .map((_, i) => (
        <span
          key={i}
          className={
            i < Math.floor(rating) ? "text-yellow-400" : "text-gray-300"
          }
        >
          ★
        </span>
      ));
  };

  if (type === "restaurant") {
    return (
      <div
        onClick={handleClick}
        className="bg-white rounded-xl overflow-hidden shadow-sm w-[320px] snap-start flex-shrink-0 cursor-pointer relative"
      >
        <img
          src={item.image || PlaceholderImg}
          alt={item.name}
          className="w-full h-52 object-bottom"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = PlaceholderImg;
          }}
        />
        {!isOpen && (() => {
          const now = new Date();
          const lagosDay = new Intl.DateTimeFormat("en-US", {
            timeZone: "Africa/Lagos",
            weekday: "short",
          }).format(now);
          const isSunday = lagosDay === "Sun";
          const isSundayClosed = isSunday && item.isSundayOpen === false;
          let label = `Opens Tomorrow At ${item.openTime || "9:00 AM"}`;
          if (isSundayClosed) {
            label = "Closed Sundays";
          }
          return (
            <div className="absolute top-4 left-4 bg-black/80 text-white px-3 py-1.5 rounded-md uppercase font-semibold tracking-wide text-sm">
              {label}
            </div>
          );
        })()}
        <div className="p-4">
          <h3 className="font-bold text-xl">{item.name}</h3>
          <p className="mb-2 text-sm text-gray-400 truncate text-ellipsis">
            {item?.address}
          </p>
          <div className="flex items-center gap-1 mb-2">
            {renderStars(item.rating)}
            <span className="text-sm text-gray-600 ml-1">
              {item.rating} ({item.reviews})
            </span>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <span>{item.cuisine}</span>
            <span>•</span>
            <span>{item.type}</span>
            <span>•</span>
            <span>{item.time}</span>
          </div>
        </div>
      </div>
    );
  }

  if (type === "store") {
    return (
      <div
        onClick={handleClick}
        className="bg-white rounded-xl overflow-hidden shadow-sm w-[320px] snap-start flex-shrink-0 cursor-pointer"
      >
        <img
          src={item.bannerImage || PlaceholderImg}
          alt={item.name}
          className="w-full h-52 object-cover"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = PlaceholderImg;
          }}
        />
        <div className="p-4">
          <h3 className="font-bold text-xl">{item.name}</h3>
          <p className="mb-2 text-sm text-gray-400 truncate text-ellipsis">
            {item?.address}
          </p>
          {item.tags && (
            <div className="flex gap-2 mb-2">
              {item.tags.map((tag, i) => (
                <span
                  key={i}
                  className="bg-gray-900 text-white text-xs px-3 py-1 rounded-full"
                >
                  {tag}
                </span>
              ))}
            </div>
          )}
          {item.rating && (
            <div className="flex items-center gap-1 mb-2">
              {renderStars(item.rating)}
              <span className="text-sm text-gray-600 ml-1">
                {item.rating} ({item.reviews})
              </span>
            </div>
          )}
          <p className="text-sm text-gray-600">{item.description}</p>
        </div>
      </div>
    );
  }

  if (type === "raw_food") {
    return (
      <div
        onClick={handleClick}
        className="bg-white rounded-xl overflow-hidden shadow-sm w-[320px] snap-start flex-shrink-0"
      >
        <img
          src={item.imageUrl || PlaceholderImg}
          alt={item.name}
          className="w-full h-52 object-cover"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = PlaceholderImg;
          }}
        />
        <div className="p-4">
          <h3 className="font-bold text-xl">{item.name}</h3>
          <p className="text-sm text-gray-400 truncate text-ellipsis">
            Item by {item?.businessName}
          </p>
          <p className="mb-2 text-sm text-gray-400 truncate text-ellipsis">
            {item?.address}
          </p>
          <button className="w-full bg-gray-900 text-white py-3 rounded-lg font-semibold hover:bg-gray-800 transition">
            <span className="small_currency">NGN</span>{" "}
            <NumberFormat
              thousandSeparator={true}
              prefix={""}
              className="numeric"
              displayType={"text"}
              value={parseFloat(item.price).toFixed(2)}
            />{" "}
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default BusinessCard;
